import { render } from "./UserRights.vue?vue&type=template&id=8e4d6400"
import script from "./UserRights.vue?vue&type=script&lang=js"
export * from "./UserRights.vue?vue&type=script&lang=js"
script.render = render

export default script